import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Select } from "antd";
import "./style.css";
import Overview from "./Overview";
import FuelVendors from "./FuelVendors";
import FleetManagers from "./FleetManagers";
import MasterReport from "./MasterReport";
import DateFilter from "../../../Components/DateFilter";

const ReportsAnalytics = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "Overview",
  );

  const titleMap = {
    Overview: "Report",
    "Fleet Managers": "Fleet Managers Reports & Analytics",
    "Fuel Vendors": "Fuel Vendors Reports & Analytics",
    "Master Report": "Master Reports & Analytics",
  };

  return (
    <div className="report">
      <div className="reports-controls">
        <div className="section-title">{titleMap[activeTab]}</div>

        <div className="date-filter-wrapper">
          <DateFilter />
        </div>
      </div>

      <div className="header-wrapper">
        <div className="report-navigation">
          <div className="nav-tabs">
            {[
              "Overview",
              "Fleet Managers",
              "Fuel Vendors",
              "Master Report",
            ].map((tab) => (
              <button
                key={tab}
                className={`nav-item ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {activeTab === "Overview" && <Overview />}
      {activeTab === "Fleet Managers" && <FleetManagers />}
      {activeTab === "Fuel Vendors" && <FuelVendors />}
      {activeTab === "Master Report" && <MasterReport />}
    </div>
  );
};

export default ReportsAnalytics;
